module.exports = __webpack_public_path__ + "img/lifecycle3.55ca3bcd.png";